import {CreditCardOutlined} from '@ant-design/icons';
import {BackendPointCardManager} from 'components/Backend/PointCard/Manager';

export default BackendPointCardManager;
export const orderNum = 5;
export const icon = <CreditCardOutlined />;
export const title = '儲值及使用量查詢';
